/* eslint-disable @typescript-eslint/indent */
import { type Signal } from '@preact/signals-react'
import { type FormInstance } from 'antd/lib'

import { type TApplication } from './applications'
import { type TAuthUserPermission } from './auth'

export const enum EFormFieldTypes {
  BOOLEAN = 'boolean',
  BOOLEAN_SWITCH = 'bool',
  CHECKLIST = 'checklist',
  CURRENCY = 'currency',
  DATE = 'date',
  DATE_TIME = 'datetime',
  ENUM = 'enum',
  ENUM_MULTI = 'multiEnum',
  FLOAT = 'float',
  INT = 'int',
  NUMBER = 'number',
  TEXT = 'text',
  UPLOAD_FILE = 'file',
  UPLOAD_IMAGE = 'upload_image',
  UPLOAD_MULTIPLE = 'upload_multiple',
  UPLOAD_MULTIPLE_DRAG = 'upload_multiple_drag',
  VARCHAR = 'varchar',
}

export const enum EFormSectionType {
  DEFAULT = 'default',
  FILE_LIST = 'file_list',
  TABLE = 'table',
}

export const enum EFormEntityType {
  SIMPLE = 'simple',
  TABLE = 'multiple',
}

export const enum EFormTableMode {
  CREATE = 'create',
  UPDATE = 'update',
  VIEW = 'view',
}

export const enum EConditionGroupType {
  DATE_IN_FUTURE = 'inFuture',
}

export interface TResetPwdData {
  confirmPassword: string
  password: string
}

export interface TFormOption {
  label: string
  value: string | number
}

export interface TFormFieldDynamicLogic {
  invalid?: {
    conditionGroup?: Array<{ attribute: string; type: EConditionGroupType }>
  }
  valid?: {
    conditionGroup?: Array<{ attribute: string; type: EConditionGroupType }>
  }
}
export interface TFormField {
  checkedChildren?: string
  className?: string
  default?: boolean | string | number | Date | null
  description?: string
  dynamicLogic: TFormFieldDynamicLogic
  label: string
  name: string
  options?: string[] | number[]
  readonly?: boolean
  render?: boolean
  required?: boolean
  type: EFormFieldTypes
  uncheckedChildrend?: string
}

export interface TFormFile {
  description?: string
  name?: string
  required?: boolean
}

export interface TFormTableColumn {
  key: string
  title: string
}

export interface TEntitySection {
  fields?: TFormField[]
  name?: string | null
}

export interface TFileViewer {
  fileBase64String: string | null
  isImage: boolean
  isPdf: boolean
  openModal: boolean
}

export interface TEntityForm {
  form: TFormField[]
  mode: EFormTableMode | null
  openDrawer: boolean
  values: TApplication
}

export interface TEntityInfo {
  label?: string
  name?: string | null
  permission?: TAuthUserPermission
  render?: boolean
  sections?: TEntitySection[]
  type?: EFormEntityType
}

export interface TFormState {
  currentEntity: Signal<TEntityInfo | null>
  currentEntityDateFields: Signal<
    Array<{ name: string; type: EFormFieldTypes }>
  >
  currentForm: Signal<TEntityInfo[]>
  currentFormInstance: Signal<FormInstance | null>
  currentFormValues: Signal<TApplication>
  currentNewApplicationId: Signal<number>
  entityForm: Signal<TEntityForm>
  fileViewer: Signal<TFileViewer>
  hasRequiredFieldsEmpty: Signal<boolean>
  showForm: Signal<boolean>
}
